export default "__VITE_ASSET__CwPT7$qV__"